/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import { useEffect, useState } from "react";

import { useSelections } from "../../context/Selections";

import PropTypes from "prop-types";

import {
  CardHeader,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";

import styled from "styled-components";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { TitleSharp } from "@mui/icons-material";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
  overflow: auto;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function DetailsMobile({ app, config }) {
  const { selections } = useSelections();
  const [selectedValue, setSelectedValue] = useState("Resumo Pontuação");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const handleChange = (event) => {
    if (event.target.value) {
      app.field("Desc_Det").selectMatch(event.target.value);
      setSelectedValue(event.target.value);
    }
  };

  const rankingVariations = {
    Ygra: "Heads",
    SjAVmLh: "Gerentes",
    Gnmjaa: "Executivos",
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Desc_Det")
        : null;
      setSelectedValue(distributors?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="container-details">
      <FormControl className="container-form-control">
        <RadioGroup
          row
          value={selectedValue}
          onChange={handleChange}
          sx={{ marginLeft: "20px", marginBottom: "16px" }}
        >
          <FormControlLabel
            value="Resumo Pontuação"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#ff007f",
                  "&.Mui-checked": {
                    color: "#dd007f",
                  },
                }}
              />
            }
            label="Resumo Pontuação"
          />

          <FormControlLabel
            value="Detalhamento Geral"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#ff007f",
                  "&.Mui-checked": {
                    color: "#dd007f",
                  },
                }}
              />
            }
            label="Detalhamento Geral"
          />

          <FormControlLabel
            value="Detalhamento Seg. Foco"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#ff007f",
                  "&.Mui-checked": {
                    color: "#dd007f",
                  },
                }}
              />
            }
            label="Detalhamento Seg. Foco"
          />

          <FormControlLabel
            value="Ranking de Vendas"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#ff007f",
                  "&.Mui-checked": {
                    color: "#dd007f",
                  },
                }}
              />
            }
            label="Ranking de Vendas"
          />

          <FormControlLabel
            value="Acompanhamento Mensal"
            control={
              <Radio
                size="small"
                sx={{
                  color: "#ff007f",
                  "&.Mui-checked": {
                    color: "#dd007f",
                  },
                }}
              />
            }
            label="Acompanhamento Mensal"
          />
        </RadioGroup>
      </FormControl>

      <LayoutCardWrapper>
        <LayoutCardsWrapper>
          <Grid container rowGap={2}>
            <LayoutCardWrapper style={{ height: "463px", paddingLeft: "10px" }}>
              {selectedValue === "Ranking de Vendas" ? (
                <div className="card-sales">
                  {Object.entries(rankingVariations).map(
                    ([variation, title]) => (
                      <div style={{ marginBottom: "30px" }}>
                        <Card
                          app={app}
                          exportContainer
                          exportTable
                          exportTableId={variation}
                          style={{ width: "100%" }}
                          className={"container-table-sales"}
                        >
                          <div className="titles-sales">
                            <span key={variation}>{title}</span>
                          </div>
                          <NativeObject
                            app={app}
                            key={variation}
                            reference={{ id: variation }}
                            style={{ margin: "5px", width: "100%" }}
                          />
                        </Card>
                      </div>
                    )
                  )}
                </div>
              ) : (
                <Card
                  app={app}
                  exportContainer
                  exportTable
                  exportTableId="LLeyt"
                  style={{ width: "400px" }}
                  className={"container-table container-table-mobile"}
                >
                  <NativeObject
                    app={app}
                    key="LLeyt"
                    reference={{ id: "LLeyt" }}
                    style={{ width: "400px" }}
                  />
                </Card>
              )}
            </LayoutCardWrapper>
          </Grid>
        </LayoutCardsWrapper>
      </LayoutCardWrapper>
    </div>
  );
}

DetailsMobile.defaultProps = {
  app: null,
  config: {},
};

DetailsMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailsMobile;
